<nav
  class="navbar navbar-expand-lg fixed-top navbar-transparent"
  color-on-scroll="100"
  id="navbar-top"
>
  <div class="container">
    <div class="navbar-translate">
      <a
        class="navbar-brand"
        [routerLink]="['/home']"
        placement="bottom"
        tooltip="Designed and Coded by Creative Tim"
      >
        <span> BLK• </span> Design System Angular
      </a>
      <button
        aria-controls="navigation-index"
        aria-label="Toggle navigation"
        class="navbar-toggler navbar-toggler"
        [attr.aria-expanded]="!isCollapsed"
        (click)="isCollapsed = !isCollapsed"
        id="navigation"
        type="button"
      >
        <span class="navbar-toggler-bar bar1"> </span>
        <span class="navbar-toggler-bar bar2"> </span>
        <span class="navbar-toggler-bar bar3"> </span>
      </button>
    </div>
    <div
      class="navbar-collapse justify-content-end"
      [collapse]="isCollapsed"
      id="navigation"
    >
      <div class="navbar-collapse-header">
        <div class="row">
          <div class="col-6 collapse-brand"><a> BLK• </a></div>
          <div class="col-6 collapse-close text-right">
            <button
              aria-controls="navigation-index"
              aria-label="Toggle navigation"
              class="navbar-toggler"
              [attr.aria-expanded]="!isCollapsed"
              (click)="isCollapsed = !isCollapsed"
              id="navigation"
              type="button"
            >
              <i class="tim-icons icon-simple-remove"> </i>
            </button>
          </div>
        </div>
      </div>
      <ul class="navbar-nav">
        <li class="nav-item p-0">
          <a
            class="nav-link"
            href="https://twitter.com/CreativeTim"
            placement="bottom"
            target="_blank"
            tooltip="Follow us on Twitter"
          >
            <i class="fab fa-twitter"> </i>
            <p class="d-lg-none d-xl-none">Twitter</p>
          </a>
        </li>
        <li class="nav-item p-0">
          <a
            class="nav-link"
            href="https://www.facebook.com/CreativeTim"
            placement="bottom"
            target="_blank"
            tooltip="Like us on Facebook"
          >
            <i class="fab fa-facebook-square"> </i>
            <p class="d-lg-none d-xl-none">Facebook</p>
          </a>
        </li>
        <li class="nav-item p-0">
          <a
            class="nav-link"
            href="https://www.instagram.com/CreativeTimOfficial"
            placement="bottom"
            target="_blank"
            tooltip="Follow us on Instagram"
          >
            <i class="fab fa-instagram"> </i>
            <p class="d-lg-none d-xl-none">Instagram</p>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/home']"> Back to Kit </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            href="https://github.com/creativetimofficial/blk-design-system-angular/issues"
          >
            Have an issue?
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>
<div class="wrapper">
  <div class="page-header">
    <img class="path" src="assets/img/blob.png" />

    <img class="path2" src="assets/img/path2.png" />

    <img class="shapes triangle" src="assets/img/triunghiuri.png" />

    <img class="shapes wave" src="assets/img/waves.png" />

    <img class="shapes squares" src="assets/img/patrat.png" />

    <img class="shapes circle" src="assets/img/cercuri.png" />

    <div class="content-center">
      <div
        class="row row-grid justify-content-between align-items-center text-left"
      >
        <div class="col-lg-6 col-md-6">
          <h1 class="text-white">
            We keep your coin <br />

            <span class="text-white"> secured </span>
          </h1>
          <p class="text-white mb-3">
            A wonderful serenity has taken possession of my entire soul, like
            these sweet mornings of spring which I enjoy with my whole heart. I
            am alone, and feel...
          </p>
          <div class="btn-wrapper mb-3">
            <p class="category text-success d-inline mr-1">From 9.99%/mo</p>
            <a
              class="btn btn-success btn-link btn-sm"
              href="javascript:void(0)"
            >
              <i class="tim-icons icon-minimal-right"> </i>
            </a>
          </div>
          <div class="btn-wrapper">
            <div class="button-container">
              <button
                class="btn btn-icon btn-simple btn-round btn-neutral mr-1"
                href="javascript:void(0)"
              >
                <i class="fab fa-twitter"> </i>
              </button>
              <button
                class="btn btn-icon btn-simple btn-round btn-neutral mr-1"
                href="javascript:void(0)"
              >
                <i class="fab fa-dribbble"> </i>
              </button>
              <button
                class="btn btn-icon btn-simple btn-round btn-neutral"
                href="javascript:void(0)"
              >
                <i class="fab fa-facebook"> </i>
              </button>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-5">
          <img
            alt="Circle image"
            class="img-fluid"
            src="assets/img/etherum.png"
          />
        </div>
      </div>
    </div>
  </div>
  <section class="section section-lg">
    <section class="section">
      <img class="path" src="assets/img/path4.png" />

      <div class="container">
        <div class="row row-grid justify-content-between">
          <div class="col-md-5 mt-lg-5">
            <div class="row">
              <div class="col-lg-6 col-sm-12 px-2 py-2">
                <div class="card card-stats">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-5 col-md-4">
                        <div class="icon-big text-center icon-warning">
                          <i class="tim-icons icon-trophy text-warning"> </i>
                        </div>
                      </div>
                      <div class="col-7 col-md-8">
                        <div class="numbers">
                          <p class="card-title">3,237</p>
                          <p></p>
                          <p class="card-category">Awards</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-sm-12 px-2 py-2">
                <div class="card card-stats upper bg-default">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-5 col-md-4">
                        <div class="icon-big text-center icon-warning">
                          <i class="tim-icons icon-coins text-white"> </i>
                        </div>
                      </div>
                      <div class="col-7 col-md-8">
                        <div class="numbers">
                          <p class="card-title">3,653</p>
                          <p></p>
                          <p class="card-category">Commits</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 col-sm-12 px-2 py-2">
                <div class="card card-stats">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-5 col-md-4">
                        <div class="icon-big text-center icon-warning">
                          <i class="tim-icons icon-gift-2 text-info"> </i>
                        </div>
                      </div>
                      <div class="col-7 col-md-8">
                        <div class="numbers">
                          <p class="card-title">593</p>
                          <p></p>
                          <p class="card-category">Presents</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-sm-12 px-2 py-2">
                <div class="card card-stats">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-5 col-md-4">
                        <div class="icon-big text-center icon-warning">
                          <i class="tim-icons icon-credit-card text-success">
                          </i>
                        </div>
                      </div>
                      <div class="col-7 col-md-8">
                        <div class="numbers">
                          <p class="card-title">10,783</p>
                          <p></p>
                          <p class="card-category">Forks</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="pl-md-5">
              <h1>
                Large <br />

                Achivements
              </h1>
              <p>
                I should be capable of drawing a single stroke at the present
                moment; and yet I feel that I never was a greater artist than
                now.
              </p>
              <br />

              <p>
                When, while the lovely valley teems with vapour around me, and
                the meridian sun strikes the upper surface of the impenetrable
                foliage of my trees, and but a few stray.
              </p>
              <br />

              <a
                class="font-weight-bold text-info mt-5"
                href="javascript:void(0)"
              >
                Show all <i class="tim-icons icon-minimal-right text-info"> </i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
  <section class="section section-lg">
    <img class="path" src="assets/img/path4.png" />

    <img class="path2" src="assets/img/path5.png" />

    <img class="path3" src="assets/img/path2.png" />

    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-12">
          <h1 class="text-center">Your best benefit</h1>
          <div class="row row-grid justify-content-center">
            <div class="col-lg-3">
              <div class="info">
                <div class="icon icon-primary">
                  <i class="tim-icons icon-money-coins"> </i>
                </div>
                <h4 class="info-title">Low Commission</h4>
                <hr class="line-primary" />

                <p>
                  Divide details about your work into parts. Write a few lines
                  about each one. A paragraph describing a feature will.
                </p>
              </div>
            </div>
            <div class="col-lg-3">
              <div class="info">
                <div class="icon icon-warning">
                  <i class="tim-icons icon-chart-pie-36"> </i>
                </div>
                <h4 class="info-title">High Incomes</h4>
                <hr class="line-warning" />

                <p>
                  Divide details about your product or agency work into parts.
                  Write a few lines about each one. A paragraph describing
                  feature will be a feature.
                </p>
              </div>
            </div>
            <div class="col-lg-3">
              <div class="info">
                <div class="icon icon-success">
                  <i class="tim-icons icon-single-02"> </i>
                </div>
                <h4 class="info-title">Verified People</h4>
                <hr class="line-success" />

                <p>
                  Divide details about your product or agency work into parts.
                  Write a few lines about each one. A paragraph describing be
                  enough.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="section section-lg section-safe">
    <img class="path" src="assets/img/path5.png" />

    <div class="container">
      <div class="row row-grid justify-content-between">
        <div class="col-md-5">
          <img class="img-fluid floating" src="assets/img/chester-wade.jpg" />

          <div class="card card-stats bg-danger">
            <div class="card-body">
              <div class="justify-content-center">
                <div class="numbers">
                  <p class="card-title">100%</p>
                  <p class="card-category text-white">Safe</p>
                </div>
              </div>
            </div>
          </div>
          <div class="card card-stats bg-info">
            <div class="card-body">
              <div class="justify-content-center">
                <div class="numbers">
                  <p class="card-title">573 K</p>
                  <p class="card-category text-white">Satisfied customers</p>
                </div>
              </div>
            </div>
          </div>
          <div class="card card-stats bg-default">
            <div class="card-body">
              <div class="justify-content-center">
                <div class="numbers">
                  <p class="card-title">10 425</p>
                  <p class="card-category text-white">Business</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="px-md-5">
            <hr class="line-success" />

            <h3>Awesome features</h3>
            <p>
              The design system comes with three pre-built pages to help you get
              started faster. You can change the text and images and you're good
              to go.
            </p>
            <ul class="list-unstyled mt-5">
              <li class="py-2">
                <div class="d-flex align-items-center">
                  <div class="icon icon-success mb-2">
                    <i class="tim-icons icon-vector"> </i>
                  </div>
                  <div class="ml-3"><h6>Carefully crafted components</h6></div>
                </div>
              </li>
              <li class="py-2">
                <div class="d-flex align-items-center">
                  <div class="icon icon-success mb-2">
                    <i class="tim-icons icon-tap-02"> </i>
                  </div>
                  <div class="ml-3"><h6>Amazing page examples</h6></div>
                </div>
              </li>
              <li class="py-2">
                <div class="d-flex align-items-center">
                  <div class="icon icon-success mb-2">
                    <i class="tim-icons icon-single-02"> </i>
                  </div>
                  <div class="ml-3"><h6>Super friendly support team</h6></div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="section section-lg">
    <img class="path" src="assets/img/path4.png" />

    <img class="path2" src="assets/img/path2.png" />

    <div class="col-md-12">
      <div class="card card-chart card-plain">
        <div class="card-header">
          <div class="row">
            <div class="col-sm-6 text-left">
              <hr class="line-primary" />

              <h5 class="card-category">Total Investments</h5>
              <h2 class="card-title">Performance</h2>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="chart-area"><canvas id="chartBig"> </canvas></div>
        </div>
      </div>
    </div>
  </section>
  <section class="section section-lg section-coins">
    <img class="path" src="assets/img/path3.png" />

    <div class="container">
      <div class="row">
        <div class="col-md-4">
          <hr class="line-info" />

          <h1>
            Choose the coin
            <span class="text-info"> that fits your needs </span>
          </h1>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="card card-coin card-plain">
            <div class="card-header">
              <img class="img-center img-fluid" src="assets/img/bitcoin.png" />
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12 text-center">
                  <h4 class="text-uppercase">Light Coin</h4>
                  <span> Plan </span>
                  <hr class="line-primary" />
                </div>
              </div>
              <div class="row">
                <ul class="list-group">
                  <li class="list-group-item">50 messages</li>
                  <li class="list-group-item">100 emails</li>
                  <li class="list-group-item">24/7 Support</li>
                </ul>
              </div>
            </div>
            <div class="card-footer text-center">
              <button class="btn btn-primary btn-simple">Get plan</button>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card card-coin card-plain">
            <div class="card-header">
              <img class="img-center img-fluid" src="assets/img/etherum.png" />
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12 text-center">
                  <h4 class="text-uppercase">Dark Coin</h4>
                  <span> Plan </span>
                  <hr class="line-success" />
                </div>
              </div>
              <div class="row">
                <ul class="list-group">
                  <li class="list-group-item">150 messages</li>
                  <li class="list-group-item">1000 emails</li>
                  <li class="list-group-item">24/7 Support</li>
                </ul>
              </div>
            </div>
            <div class="card-footer text-center">
              <button class="btn btn-success btn-simple">Get plan</button>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card card-coin card-plain">
            <div class="card-header">
              <img class="img-center img-fluid" src="assets/img/ripp.png" />
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12 text-center">
                  <h4 class="text-uppercase">Bright Coin</h4>
                  <span> Plan </span>
                  <hr class="line-info" />
                </div>
              </div>
              <div class="row">
                <ul class="list-group">
                  <li class="list-group-item">350 messages</li>
                  <li class="list-group-item">10K emails</li>
                  <li class="list-group-item">24/7 Support</li>
                </ul>
              </div>
            </div>
            <div class="card-footer text-center">
              <button class="btn btn-info btn-simple">Get plan</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <footer class="footer">
    <div class="container">
      <div class="row">
        <div class="col-md-3"><h1 class="title">BLK•</h1></div>
        <div class="col-md-3">
          <ul class="nav">
            <li class="nav-item">
              <a class="nav-link" [routerLink]="['/home']"> Home </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" [routerLink]="['/landing']"> Landing </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" [routerLink]="['/register']"> Register </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" [routerLink]="['/profile']"> Profile </a>
            </li>
          </ul>
        </div>
        <div class="col-md-3">
          <ul class="nav">
            <li class="nav-item">
              <a class="nav-link" href="https://creative-tim.com/contact-us?ref=blkdsa-footer">
                Contact Us
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://creative-tim.com/about-us?ref=blkdsa-footer">
                About Us
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://creative-tim.com/blog?ref=blkdsa-footer">
                Blog
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://opensource.org/licenses/MIT">
                License
              </a>
            </li>
          </ul>
        </div>
        <div class="col-md-3">
          <h3 class="title">Follow us:</h3>
          <div class="btn-wrapper profile">
            <a
              class="btn btn-icon btn-neutral btn-round btn-simple mr-1"
              href="https://twitter.com/creativetim"
              target="_blank"
            >
              <i class="fab fa-twitter"> </i>
            </a>
            <a
              class="btn btn-icon btn-neutral btn-round btn-simple mr-1"
              href="https://www.facebook.com/creativetim"
              target="_blank"
            >
              <i class="fab fa-facebook-square"> </i>
            </a>
            <a
              class="btn btn-icon btn-neutral btn-round btn-simple"
              href="https://dribbble.com/creativetim"
              target="_blank"
            >
              <i class="fab fa-dribbble"> </i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</div>
